module.exports = "https://cwa.roocdn.com/_next/static/favicon-32x32.61b7a58d.png";